import { computed, getCurrentInstance } from "@vue/composition-api";
import { SystemSettings } from "@scrile/api-provider/dist/api/SystemSettingsProvider";
import { ACTION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";

export default function() {
  const vm = getCurrentInstance();
  const systemSettings = computed<StateRoot["systemSettings"]>(() => vm?.$store.state.systemSettings ?? null);
  const currentPaymentSystem = computed<StateRoot["currentPaymentSystem"]>(
    () => vm?.$store.state.currentPaymentSystem ?? null
  );
  const creditCardAllowed = computed<StateRoot["creditCardAllowed"]>(() => vm?.$store.state.creditCardAllowed ?? true);
  const getData = () => vm?.$store.dispatch(ACTION_TYPES.GET_SYSTEM_SETTINGS) as Promise<SystemSettings>;
  return {
    systemSettings,
    currentPaymentSystem,
    creditCardAllowed,
    getData,
  };
}
